module.exports = __webpack_public_path__ + "img/cashback-racoon-mask.bf73109.3bc5a62f.png";